import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getRemoteConfig } from 'firebase/remote-config'

let app
let db
let storage
let remoteConfig
let analytics

export const initializeFirebase = () => {
  if (app) return { app, db, storage, remoteConfig, analytics } // Already initialized

  const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  }

  app = initializeApp(firebaseConfig)
  db = getFirestore(app)
  storage = getStorage(app)
  remoteConfig = getRemoteConfig(app)
  analytics = getAnalytics(app) // Initialize analytics here too
  
  // Set a shorter cache time for development
  const isDev = import.meta.env.MODE === 'development'
  remoteConfig.settings.minimumFetchIntervalMillis = isDev ? 30000 : 3600000 // 30 seconds in dev, 1 hour in prod

  console.log('Firebase Initialized')
  return { app, db, storage, remoteConfig, analytics }
}

export { app, db, storage, remoteConfig, analytics }
